import React, { useContext, memo } from 'react';
import styles from './MemoryOverviewWidget.module.css';
import { DatabaseIcon } from 'assets/icons';
import { useMemory } from '../../hooks/useMemory';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js';
import Loader from 'components/shared/loader/Loader';
import ThemeContext from 'config/context/themeContext';
import { formatBytes } from 'lib/formatBytes';
import WidgetShell from 'pages/dashboard/components/WidgetShell';

// Only register what we need
ChartJS.register(ArcElement, Tooltip);

const MemoryOverviewWidget = memo(() => {
    const { dark } = useContext(ThemeContext);
    const { memoryData, loading, error, hasValidCache } = useMemory();

    if (loading && !memoryData) return (
        <WidgetShell title="Memory Overview" icon={<DatabaseIcon />}>
            <div style={{ height: '120px', display: 'grid', placeItems: 'center' }}>
                <Loader />
            </div>
        </WidgetShell>
    );

    if (!memoryData) return (
        <WidgetShell title="Memory Overview" icon={<DatabaseIcon />}>
            <div style={{ height: '120px', display: 'grid', placeItems: 'center' }}>
                <div>{error ? `Error: ${error}` : 'No data available'}</div>
            </div>
        </WidgetShell>
    );

    const data = {
        labels: ['Bytes used', 'Bytes left'],
        datasets: [{
            data: [memoryData.user_memory.used_bytes, memoryData.user_memory.free_bytes],
            backgroundColor: ['#37a0f6', '#e5e7eb'],
            borderWidth: 0,
            cutout: '75%',
        }]
    };

    const options = {
        plugins: {
            legend: {
                display: false
            }
        }
    };

    const usedPercent = (memoryData.user_memory.used_bytes / memoryData.user_memory.total_bytes * 100).toFixed(2);

    return (

        <WidgetShell title="Memory Overview" icon={<DatabaseIcon />}>
            <div className={`${styles.memory_overview_widget} ${dark ? styles.dark : ""} `}>
                <div className={styles.memory_overview_chart}>
                    <Doughnut data={data} options={options} />
                    <span>{usedPercent}%</span>
                </div>
                <div className={styles.memory_overview_data}>
                    <p>Used: <span>{formatBytes(memoryData.user_memory.used_bytes)}</span></p>
                    <p>Total: <span>{formatBytes(memoryData.user_memory.total_bytes)}</span></p>
                    <p>Free: <span>{formatBytes(memoryData.user_memory.free_bytes)}</span></p>
                    {hasValidCache && <p className={styles.cache_indicator}>✓ Cached</p>}
                </div>
            </div>
        </WidgetShell>
    );
});

MemoryOverviewWidget.displayName = 'MemoryOverviewWidget';

export default MemoryOverviewWidget;